import { DeviceLocationProvider } from "./DeviceLocationProvider";
import { MockLocationProvider } from "./MockLocationProvider";

export const LocationProvider =
  import.meta.env.VITE_MOCK_GEOLOCATION === "true"
    ? MockLocationProvider
    : DeviceLocationProvider;
